import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_app",
  ref: "ModalCreateScheduleRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header pt-8 pb-5 px-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fs-2 fw-bold" }, "Nueva cita", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2x" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body py-lg-3 px-10" }
const _hoisted_9 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-lg-row py-5",
  id: "kt_modal_create_app_stepper",
  ref: "createAppRef"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-row-auto w-100 w-lg-300px\"><div class=\"stepper-nav\"><div class=\"stepper-item me-5 current\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number fs-5 fw-bold\">1</span></div><div class=\"stepper-label\"><h3 class=\"fs-5 fw-bold stepper-title\">Tipo de Cita</h3><div class=\"stepper-desc fs-base\">Selecciona la cita</div></div></div><div class=\"stepper-item me-5\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number fs-5 fw-bold\">2</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title fs-5 fw-bold\">Cliente</h3><div class=\"stepper-desc fs-base\">Datos del cliente</div></div></div><div class=\"stepper-item me-5\" data-kt-stepper-element=\"nav\"><div class=\"stepper-line w-40px\"></div><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number fs-5 fw-bold\">3</span></div><div class=\"stepper-label\"><h3 class=\"stepper-title fs-5 fw-bold\">Vehículo</h3><div class=\"stepper-desc fs-base\">Datos del vehículo</div></div></div></div></div>", 1)
const _hoisted_11 = { class: "flex-row-fluid" }
const _hoisted_12 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = { class: "fv-row mb-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tipo de Cita")
], -1)
const _hoisted_16 = { class: "mt-3 d-flex" }
const _hoisted_17 = { class: "form-check form-check-custom fs-base form-check-solid" }
const _hoisted_18 = { class: "d-flex align-items-center ms-2" }
const _hoisted_19 = { class: "d-flex flex-column" }
const _hoisted_20 = { class: "fw-bold fs-base" }
const _hoisted_21 = { class: "fv-row mb-10" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Día de la cita")
], -1)
const _hoisted_23 = { class: "fv-row mb-10" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Horario de la cita")
], -1)
const _hoisted_25 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Valuador")
], -1)
const _hoisted_27 = { "data-kt-stepper-element": "content" }
const _hoisted_28 = { class: "w-100" }
const _hoisted_29 = { class: "fv-row" }
const _hoisted_30 = { class: "d-flex flex-column mb-2" }
const _hoisted_31 = { class: "row g-9 mb-2" }
const _hoisted_32 = { class: "col-md-6 fv-row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nombre")
], -1)
const _hoisted_34 = { class: "position-relative" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "button",
    class: "svg-icon svg-icon-1hx pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "isax-user" })
  ])
], -1)
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-md-6 fv-row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Apellidos")
], -1)
const _hoisted_40 = { class: "input-group mb-1" }
const _hoisted_41 = { class: "d-flex flex-column mb-2" }
const _hoisted_42 = { class: "fv-row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Correo electrónico")
], -1)
const _hoisted_44 = { class: "position-relative" }
const _hoisted_45 = { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }
const _hoisted_46 = {
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "d-flex flex-column mb-2" }
const _hoisted_50 = { class: "fv-row" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Teléfono")
], -1)
const _hoisted_52 = { class: "position-relative" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "button",
    class: "svg-icon svg-icon-1hx pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "isax-call" })
  ])
], -1)
const _hoisted_54 = { "data-kt-stepper-element": "content" }
const _hoisted_55 = { class: "w-100" }
const _hoisted_56 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Vehículo de interés")
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", {
  value: "1",
  selected: "",
  disabled: ""
}, "Selecciona una marca", -1)
const _hoisted_59 = {
  key: 1,
  class: "fv-row mb-10"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Marca")
], -1)
const _hoisted_61 = {
  key: 2,
  class: "fv-row mb-10"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Modelo")
], -1)
const _hoisted_63 = {
  key: 3,
  class: "fv-row mb-10"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Año")
], -1)
const _hoisted_65 = {
  key: 4,
  class: "fv-row mb-10"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Versión")
], -1)
const _hoisted_67 = {
  key: 5,
  class: "fv-row mb-10"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Cantidad de dueños")
], -1)
const _hoisted_69 = {
  key: 6,
  class: "fv-row mb-10"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Kilometraje del vehículo")
], -1)
const _hoisted_71 = { class: "d-flex flex-stack pt-10" }
const _hoisted_72 = {
  key: 0,
  class: "me-2"
}
const _hoisted_73 = { class: "me-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Anterior", -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = {
  key: 0,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Crear cita", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress fs-base" }, [
  /*#__PURE__*/_createTextVNode(" Espera por favor... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_79 = [
  _hoisted_77,
  _hoisted_78
]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Continuar", -1)
const _hoisted_81 = [
  _hoisted_80
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loaderClientVue = _resolveComponent("loaderClientVue")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
              class: "pointer"
            }, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_loaderClientVue, { showLoader: _ctx.loading }, null, 8, ["showLoader"]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("form", {
                  class: "form mx-auto",
                  novalidate: "novalidate",
                  id: "kt_modal_create_app_form",
                  onSubmit: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typesSchedules, (types, index) => {
                            return (_openBlock(), _createElementBlock("label", {
                              class: "d-flex flex-stack me-5 cursor-pointer",
                              key: index
                            }, [
                              _createElementVNode("span", _hoisted_17, [
                                _createVNode(_component_Field, {
                                  class: "form-check-input",
                                  type: "radio",
                                  name: "typeSchedule",
                                  value: types.id,
                                  id: 'type-' + types.id,
                                  checked: "{{types.active}}",
                                  onChange: ($event: any) => (_ctx.onChangeTypeSchedule(types.id)),
                                  modelValue: _ctx.formData.typeSchedule,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.typeSchedule) = $event))
                                }, null, 8, ["value", "id", "onChange", "modelValue"])
                              ]),
                              _createElementVNode("span", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(types.label), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "typeSchedule"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_Field, {
                          class: "form-control form-control-solid fs-base border-1 border-secondary ps-10",
                          name: "day",
                          type: "date",
                          modelValue: _ctx.formData.day,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.day) = $event))
                        }, {
                          default: _withCtx(({ value, errorMessage, handleChange }) => [
                            _createVNode(_component_el_form_item, { error: errorMessage }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Datepicker, {
                                  placeholder: 'Selecciona el día',
                                  enableTimePicker: false,
                                  monthChangeOnScroll: false,
                                  position: "left",
                                  locale: "es",
                                  dayNames: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
                                  selectText: 'Seleccionar',
                                  cancelText: 'Cancelar',
                                  preview: false,
                                  "model-value": value,
                                  "onUpdate:modelValue": handleChange,
                                  "disabled-dates": _ctx.disabledDate,
                                  change: _ctx.onChangeDay(value),
                                  class: _normalizeClass('dp__theme_dark')
                                }, null, 8, ["model-value", "onUpdate:modelValue", "disabled-dates", "change"])
                              ]),
                              _: 2
                            }, 1032, ["error"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createVNode(_component_Field, {
                          name: "time",
                          autocomplete: "off",
                          class: "form-select form-select-solid select2-hidden-accessible w-100",
                          placeholder: "Selecciona una horario",
                          modelValue: _ctx.formData.time,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.time) = $event))
                        }, {
                          default: _withCtx(({ value, errorMessage, handleChange }) => [
                            _createVNode(_component_el_form_item, { error: errorMessage }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  name: "time",
                                  size: "large",
                                  class: "w-100",
                                  value: value,
                                  "model-value": value,
                                  "onUpdate:modelValue": handleChange,
                                  placeholder: "Selecciona una horario",
                                  loading: _ctx.loading,
                                  disabled: _ctx.ScheduleTimes.length == 0
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ScheduleTimes, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: index,
                                        label: item.hora,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["error"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      (_ctx.formData.typeSchedule == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _hoisted_26,
                            _createVNode(_component_Field, {
                              name: "appraiser",
                              class: "form-select form-select-solid fs-base select2-hidden-accessible",
                              placeholder: "Elige un valuador",
                              modelValue: _ctx.formData.appraiser,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.appraiser) = $event))
                            }, {
                              default: _withCtx(({ value, errorMessage, handleChange }) => [
                                _createVNode(_component_el_form_item, { error: errorMessage }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      name: "appraiser",
                                      value: value,
                                      "model-value": value,
                                      size: "large",
                                      "onUpdate:modelValue": handleChange,
                                      placeholder: "Elige un valuador"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appraiserOp, (valuador) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: valuador.id,
                                            label: valuador.name + ' ' + valuador.last_name,
                                            value: valuador.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "model-value", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1032, ["error"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("div", _hoisted_34, [
                                _createVNode(_component_Field, {
                                  type: "text",
                                  class: "form-control form-control-solid fs-base border-1 border-secondary ps-10",
                                  placeholder: "Luis Daniel",
                                  name: "firtsname",
                                  modelValue: _ctx.formData.firtsname,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.firtsname) = $event))
                                }, null, 8, ["modelValue"]),
                                _hoisted_35
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createVNode(_component_ErrorMessage, {
                                    class: "fv-plugins-message-container invalid-feedback",
                                    name: "firtsname"
                                  })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _hoisted_39,
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_Field, {
                                  type: "text",
                                  class: "form-control form-control-solid border-1 fs-base border-secondary ps-5",
                                  name: "lastname",
                                  placeholder: "Díaz",
                                  modelValue: _ctx.formData.lastname,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.lastname) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, {
                                  class: "fv-plugins-message-container invalid-feedback",
                                  name: "lastname"
                                })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_Field, {
                                type: "text",
                                class: "form-control form-control-solid fs-base border-1 border-secondary ps-10",
                                placeholder: "example@mail.com",
                                name: "email",
                                modelValue: _ctx.formData.email,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.email) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("span", _hoisted_46, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Correo.svg" })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createVNode(_component_ErrorMessage, { name: "email" })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _hoisted_51,
                            _createElementVNode("div", _hoisted_52, [
                              _withDirectives(_createVNode(_component_Field, {
                                type: "text",
                                class: "form-control form-control-solid border-1 fs-base border-secondary ps-10",
                                placeholder: "333-333-3331",
                                name: "phone",
                                modelValue: _ctx.formData.phone,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.phone) = $event))
                              }, null, 8, ["modelValue"]), [
                                [_directive_maska, {
                                  mask: 'Z##-###-####',
                                  tokens: { Z: { pattern: /[1-9]/ } },
                                }]
                              ]),
                              _hoisted_53
                            ]),
                            _createVNode(_component_ErrorMessage, {
                              name: "phone",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      (_ctx.formData.typeSchedule == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _hoisted_57,
                            _createVNode(_component_Field, {
                              name: "vehicle",
                              class: "form-select form-select-solid fs-base select2-hidden-accessible",
                              placeholder: "Selecciona un vehiculo",
                              modelValue: _ctx.formData.vehicle,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.vehicle) = $event))
                            }, {
                              default: _withCtx(({ value, errorMessage, handleChange }) => [
                                _hoisted_58,
                                _createVNode(_component_el_form_item, { error: errorMessage }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      name: "vehicle",
                                      value: value,
                                      "model-value": value,
                                      "onUpdate:modelValue": handleChange,
                                      filterable: "",
                                      size: "large",
                                      remote: "",
                                      "reserve-keyword": "",
                                      placeholder: "Elige el vehículo de interés",
                                      "remote-method": _ctx.searchVehicle,
                                      loading: _ctx.loading
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehiclesOp, (item, index) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: index,
                                            label:  item.brand + ' ' + item.model + ' - ' + item.year + ' - $' + _ctx.formatPrice(item.price),
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "remote-method", "loading"])
                                  ]),
                                  _: 2
                                }, 1032, ["error"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.typeSchedule == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _hoisted_60,
                            _createVNode(_component_Field, {
                              name: "brand",
                              autocomplete: "off",
                              class: "form-select form-select-solid select2-hidden-accessible",
                              placeholder: "Selecciona una marca",
                              modelValue: _ctx.formData.brand.id,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.brand.id) = $event))
                            }, {
                              default: _withCtx(({ value, errorMessage, handleChange }) => [
                                _createVNode(_component_el_form_item, { error: errorMessage }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      class: "w-100",
                                      name: "brand",
                                      value: value,
                                      "model-value": _ctx.listBrands.filter(item => item?.id == value)[0]?.name,
                                      "onUpdate:modelValue": handleChange,
                                      placeholder: "Selecciona una marca",
                                      loading: _ctx.loading,
                                      size: "large",
                                      onChange: _cache[10] || (_cache[10] = ($event: any) => {_ctx.getModels(); _ctx.setBrand();}),
                                      disabled: _ctx.listBrands.length == 0
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listBrands, (item, index) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: index,
                                            label: item.name,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "disabled"])
                                  ]),
                                  _: 2
                                }, 1032, ["error"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.typeSchedule == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _hoisted_62,
                            _createVNode(_component_Field, {
                              name: "model",
                              autocomplete: "off",
                              class: "form-select form-select-solid select2-hidden-accessible",
                              placeholder: "Selecciona un modelo",
                              modelValue: _ctx.formData.model.id,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.model.id) = $event))
                            }, {
                              default: _withCtx(({ value, errorMessage, handleChange }) => [
                                _createVNode(_component_el_form_item, { error: errorMessage }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      name: "model",
                                      size: "large",
                                      class: "w-100",
                                      value: value,
                                      "model-value": _ctx.listModels.filter(item => item?.id == value)[0]?.name,
                                      "onUpdate:modelValue": handleChange,
                                      placeholder: "Selecciona un modelo",
                                      loading: _ctx.loading,
                                      onChange: _cache[12] || (_cache[12] = ($event: any) => {_ctx.getYears(); _ctx.setModel();}),
                                      disabled: _ctx.listModels.length == 0
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listModels, (item, index) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: index,
                                            label: item.name,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "disabled"])
                                  ]),
                                  _: 2
                                }, 1032, ["error"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.typeSchedule == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _hoisted_64,
                            _createVNode(_component_Field, {
                              name: "year",
                              autocomplete: "off",
                              class: "form-select form-select-solid select2-hidden-accessible",
                              placeholder: "Selecciona un año",
                              modelValue: _ctx.formData.year.id,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.year.id) = $event))
                            }, {
                              default: _withCtx(({ value, errorMessage, handleChange }) => [
                                _createVNode(_component_el_form_item, { error: errorMessage }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      name: "year",
                                      size: "large",
                                      class: "w-100",
                                      value: value,
                                      "model-value": _ctx.listYears.filter(item => item?.id == value)[0]?.name,
                                      "onUpdate:modelValue": handleChange,
                                      placeholder: "Selecciona un año",
                                      loading: _ctx.loading,
                                      onChange: _cache[14] || (_cache[14] = ($event: any) => {_ctx.getVersions(); _ctx.setYear();}),
                                      disabled: _ctx.listYears.length == 0
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listYears, (item, index) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: index,
                                            label: item.name,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "disabled"])
                                  ]),
                                  _: 2
                                }, 1032, ["error"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.typeSchedule == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _hoisted_66,
                            _createVNode(_component_Field, {
                              name: "version",
                              autocomplete: "off",
                              class: "form-select form-select-solid select2-hidden-accessible w-100",
                              placeholder: "Selecciona una version",
                              modelValue: _ctx.formData.version.id,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.version.id) = $event))
                            }, {
                              default: _withCtx(({ value, errorMessage, handleChange }) => [
                                _createVNode(_component_el_form_item, { error: errorMessage }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      name: "version",
                                      size: "large",
                                      class: "w-100",
                                      value: value,
                                      "model-value": _ctx.listVersions.filter(item => item?.id == value)[0]?.name,
                                      "onUpdate:modelValue": handleChange,
                                      placeholder: "Selecciona una version",
                                      loading: _ctx.loading,
                                      onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setVersion())),
                                      disabled: _ctx.listVersions.length == 0
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listVersions, (item, index) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: index,
                                            label: item.name,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "disabled"])
                                  ]),
                                  _: 2
                                }, 1032, ["error"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.typeSchedule == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _hoisted_68,
                            _createVNode(_component_Field, {
                              name: "owners",
                              class: "form-select form-select-solid fs-base select2-hidden-accessible",
                              modelValue: _ctx.formData.owners,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.owners) = $event))
                            }, {
                              default: _withCtx(({ value, errorMessage, handleChange }) => [
                                _createVNode(_component_el_form_item, { error: errorMessage }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input_number, {
                                      value: value,
                                      class: "w-100",
                                      size: "large",
                                      "model-value": value,
                                      "onUpdate:modelValue": handleChange,
                                      min: 0
                                    }, null, 8, ["value", "model-value", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1032, ["error"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.typeSchedule == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _hoisted_70,
                            _createVNode(_component_Field, {
                              type: "text",
                              autocomplete: "off",
                              placeholder: "000,000",
                              class: "form-control form-control-solid fs-base border-1 border-secondary",
                              name: "km",
                              modelValue: _ctx.formData.km,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.km) = $event)),
                              onChange: _ctx.addKm
                            }, null, 8, ["modelValue", "onChange"]),
                            _createVNode(_component_ErrorMessage, {
                              class: "fv-plugins-message-container invalid-feedback",
                              name: "km"
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    (_ctx.currentStepIndex == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-lg btn-secondary me-3",
                            "data-kt-stepper-action": "close",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.closeModal()))
                          }, " Descartar ")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-lg btn-secondary me-3",
                        "data-kt-stepper-action": "previous",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.previousStep()))
                      }, _hoisted_75)
                    ]),
                    _createElementVNode("div", null, [
                      (_ctx.currentStepIndex > 2)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_76, _hoisted_79))
                        : _createCommentVNode("", true),
                      (_ctx.currentStepIndex < 3)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-lg btn-primary",
                            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.confirmTosave && _ctx.confirmTosave(...args)))
                          }, _hoisted_81))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 32)
              ])
            ], 512)
          ])
        ])
      ])
    ], 512)
  ]))
}